import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { useUser } from "@/redux/user";
import { api } from "@/services/api";
import { Button } from "@/components/ui/button";
import RecoveryCodePanel from "@/modules/register/RecoveryCodePanel";

export default function RecoveryCode() {
  const { t } = useTranslation("auth");
  const { username, hasRecoveryCode } = useUser();
  const [password, setPassword] = useState("");
  const [code, setCode] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!hasRecoveryCode) return null;
  return (
    <section
      className="ym-hide-content mt-8 space-y-3 border-t pt-5"
      data-private
    >
      <h2 className="text-lg font-semibold">{t("recoveryCodeLabel")}</h2>
      <p className="text-sm text-altgray-600">
        {t("replaceRecoveryCodeExplanation")}
      </p>
      {code ? (
        <RecoveryCodePanel code={code} username={username} />
      ) : (
        <form
          className="space-y-3"
          onSubmit={async (event) => {
            event.preventDefault();
            if (busy) return;
            setBusy(true);
            setError("");
            try {
              const result = await api.post("/password/recovery-code/new", {
                currentPassword: password,
              });
              setCode(result.data.recoveryCode);
              setPassword("");
            } catch (err: any) {
              setError(
                t(
                  err?.response?.status === 429
                    ? "recoveryTryLater"
                    : "currentPasswordInvalid"
                )
              );
            } finally {
              setBusy(false);
            }
          }}
        >
          <label className="block text-sm" htmlFor="recovery-current-password">
            {t("currentAccountPassword")}
          </label>
          <input
            id="recovery-current-password"
            type="password"
            autoComplete="current-password"
            required
            className="w-full rounded border p-3"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <p role="alert" className="text-sm text-red-700">
              {error}
            </p>
          )}
          <Button type="submit" variant="outline" disabled={busy}>
            {t("replaceRecoveryCode")}
          </Button>
        </form>
      )}
    </section>
  );
}
